import { createStore } from 'vuex'

export default createStore({
  state: {
    usuario: {
      
    }
  },
  getters: {
  },
  mutations: {

    definelogin(state, payload){
      state.usuario = payload
    }

  },
  actions: {
  },
  modules: {
  }
})
